module.exports = __webpack_public_path__ + "img/product_66.fbe10ae.webp";